import React             from 'react';
import {observer,inject} from 'mobx-react';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                               ToolTip                         ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export const ToolTip = inject(['store'])(observer(class ToolTip extends React.Component {

      /* ------------------------------------------------ */
      /* Récupération de la hauteur du contenu du ToolTip */
      /* ------------------------------------------------ */

        componentDidUpdate() {

          let largeur = 0;
          let hauteur = 0;

          if (this.divToolTip)
          {
            hauteur = this.divToolTip.clientHeight;
            largeur = this.divToolTip.clientWidth;
          }

            this.props.store.storeToolTip.majDimensions (hauteur,largeur)
        }

      /* ---------------------- */
      /* Affichage du composant */
      /* ---------------------- */

        render() {

            if (!this.props.store.storeToolTip.afficherToolTip) return null;

            /* ------------------- */
            /* Position du tooltip */
            /* ------------------- */

            const style = {  
                position : 'absolute' ,
                zIndex   : 99 ,
                top  : this.props.store.storeToolTip.coordToolTip.y + 'px',
                left : this.props.store.storeToolTip.coordToolTip.x + 'px'
              }


            /* ------------------- */
            /* Renvoi du composant */
            /* ------------------- */

            return (
                <div style={style} ref={ (divToolTip) => this.divToolTip = divToolTip} >
                    {this.props.store.storeToolTip.contenuToolTip}
                </div>
            );
        }
    } // Fin de la classe TooTip
))


// WEBPACK FOOTER //
// ./src/components/commun/ToolTip.js